const persianNumberFormatter = new Intl.NumberFormat('fa-IR');
const percentFormatter = new Intl.NumberFormat('fa-IR', {
  style: 'percent',
  maximumFractionDigits: 1,
});

export const formatNumber = (value: number): string => persianNumberFormatter.format(value);

export const formatPercent = (value: number): string =>
  percentFormatter.format(Number.isFinite(value) ? value : 0);

export const getLeadDisplayName = (lead: {
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
}): string => {
  const personName = [lead.firstName, lead.lastName].filter(Boolean).join(' ').trim();
  return personName || lead.companyName || 'بدون نام';
};

export const maskMobile = (mobile: string | null): string => {
  if (!mobile || mobile.length < 7) return mobile || '—';
  return `${mobile.slice(0, 4)}•••${mobile.slice(-4)}`;
};
